import * as yup from 'yup';

export function passwordRequirements({
  email,
  username,
  confirmation = null,
  currentPassword = null,
}) {
  const required = yup.string().required('Password is required');

  const min = yup.string().min(12, 'Password has at least 12 characters');

  const uppercase = yup.string().matches(/[A-Z]/, {
    name: 'uppercase',
    message: 'Password has at least one uppercase character',
  });

  const lowercase = yup.string().matches(/[a-z]/, {
    name: 'lowercase',
    message: 'Password has at least one lowercase letter',
  });

  const digit = yup.string().matches(/[0-9]/, {
    name: 'digit',
    message: 'Password has at least one digit',
  });

  const special = yup.string().matches(/[^A-Za-z0-9]/, {
    name: 'special',
    message: 'Password has at least one special character',
  });

  const similarity =
    email || username
      ? yup
          .string()
          .test(
            'similarity',
            'Password must not contain parts of username or email',
            function (value, _context) {
              if (!value) {
                return false;
              }

              return (
                containsPartsOfThing(value, email) ||
                containsPartsOfThing(value, username)
              );
            },
          )
      : yup.string();

  const matches =
    confirmation && confirmation !== ''
      ? yup.string().oneOf([confirmation], 'Passwords must match')
      : yup.string();

  const sameAsCurrent =
    currentPassword && currentPassword !== ''
      ? yup
          .string()
          .notOneOf(
            [currentPassword],
            'Password is different than the current one',
          )
      : yup.string();

  const schema = required
    .concat(min)
    .concat(uppercase)
    .concat(lowercase)
    .concat(digit)
    .concat(special)
    .concat(similarity)
    .concat(matches)
    .concat(sameAsCurrent);

  const schemas = [
    {
      name: 'required',
      message: 'Password is required',
      schema: required,
    },
    {
      name: 'min',
      message: 'Password has at least 12 characters',
      schema: min,
    },
    {
      name: 'uppercase',
      message: 'Password has at least one uppercase character',
      schema: uppercase,
    },
    {
      name: 'lowercase',
      message: 'Password has at least one lowercase character',
      schema: lowercase,
    },
    {
      name: 'digit',
      message: 'Password has at least one digit',
      schema: digit,
    },
    {
      name: 'special',
      message: 'Password has at least one special character',
      schema: special,
    },
  ];

  if (email || username) {
    schemas.push({
      name: 'similarity',
      message: 'Password must not contain parts of username or email',
      schema: matches,
    });
  }

  // Allow for the empty string ('')
  if (typeof confirmation !== 'undefined' && confirmation !== null) {
    schemas.push({
      name: 'matches',
      message: 'Passwords must match',
      schema: matches,
    });
  }

  if (typeof currentPassword !== 'undefined' && currentPassword !== null) {
    schemas.push({
      name: 'same_as_current',
      message: 'Password is different than the current one',
      schema: sameAsCurrent,
    });
  }

  return {
    schema,
    schemas,
  };
}

function containsPartsOfThing(value, thing) {
  if (thing !== '' && !thing) {
    return false;
  }

  const [local, domain] = String(thing).toLowerCase().split('@');
  const p = String(value).toLowerCase();

  const localTokens = (local || '').split(/[.+_-]/).filter(Boolean);
  const domainTokens = (domain || '').split('.').filter(Boolean);

  const forbidden = new Set(
    [local, ...localTokens, domain, ...domainTokens].filter(Boolean),
  );

  for (const token of forbidden) {
    if (token.length < 3) {
      continue;
    }

    if (p.includes(token)) {
      return false;
    }
  }

  return true;
}
